<template>
    <div class="home">
        <van-search v-model="value" placeholder="请输入商品名称" @search="handleSearch" />
        <van-tree-select :items="items" :main-active-index.sync="active" @click-nav="handleGoodsList" height="">
            <template #content>
                <van-grid v-if="curCategoryName.includes('充电服务')">
                    <van-grid-item v-for="(item, index) in carportList" :key="index">
                        <h6>{{ item.publicAreaName }}</h6>
                        <strong>{{ item.freePorts }}</strong>
                        <span>空闲</span>
                        <p>共{{ item.allPorts }}个插座</p>
                    </van-grid-item>
                </van-grid>
                <van-card v-for="item in list" :key="item.GoodsId" :price="item.Price && (item.Price * 1).toFixed(2)"
                                :title="item.GoodsName" :thumb="'/' + item.ImgUrl" @click="handleGoodsDetail(item)">
                    <template #num>
                        {{ item.GoodsName.includes('充电服务') ? item.Stock + '分钟' : '' }}
                    </template>
                </van-card>
                <van-empty description="暂无数据" v-if="!list.length" />
            </template>
        </van-tree-select>
        <van-goods-action>
            <van-goods-action-icon icon="shop-o" text="订单" @click="handleGoOrder" />
            <van-goods-action-icon icon="cart-o" text="购物车" @click="handleGoShopCart" />
        </van-goods-action>
    </div>
</template>

<script>
// @ is an alias to /src
import { goodsList, goodsTypeList, statisticsLvCCPorts4Mobile } from '@/api/api'
export default {
    name: 'HomeView',
    components: {},
    data() {
        return {
            value: '',
            active: 0,
            items: [],
            list: [],
            curCategoryName: '全部',
            carportList: []
        };
    },
    mounted() {
        window.scanResult = this.scanResult;
        this.handleGoodsTypeList()
    },
    methods: {
        handleSearch(val) {
            this.value = val;
            this.handleGoodsList();
        },
        handleGoodsTypeList() {
            goodsTypeList({ communityId: localStorage.getItem('communityId') }).then(res => {
                if (res.code == 0) {
                    this.items = [{ text: '全部', id: '' }].concat(res.data.map(item => {
                        return {
                            text: item.name,
                            id: item.code
                        }
                    }))
                    this.handleGoodsList()
                }
            })
        },
        handleGoodsList() {
            this.curCategoryName = this.items[this.active]['text'];
            goodsList({ CommunityId: localStorage.getItem('communityId'), GoodsName: this.value, TypeCode: this.items[this.active]['id'], page: 1, limit: 9999 }).then(res => {
                if (res.code == 0) {
                    this.list = res.data.Data;
                }
            })
            if (this.curCategoryName.includes('充电服务')) {
                statisticsLvCCPorts4Mobile({ CommunityId: localStorage.getItem('communityId') }).then(res => {
                    console.log(res);
                    if (res.code === 0) {
                        this.carportList = res.data;
                    }
                })
            }
        },
        handleGoOrder() {
            this.$router.push('/order-list')
        },
        handleGoShopCart() {
            this.$router.push('/shop-cart')
        },
        handleGoodsDetail(item) {
            if (item.GoodsName.includes('充电服务')) {
                this.chargServiceItem = item;
                var u = navigator.userAgent;

                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器

                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

                if (isAndroid) {

                    window.android.openScan();

                } else {

                    window.webkit.messageHandlers.openScan.postMessage(null);

                }


            } else {
                this.$router.push({ path: '/goods-detail', query: { GoodsId: item.GoodsId, Price: item.Price } })
            }
        },
        scanResult(data) {
            this.$router.push({ path: '/charge-service-detail', query: { ScanResult: encodeURIComponent(JSON.stringify({ ...data, ...this.chargServiceItem })) } })
            // window.location.href = "chargServiceDetail.html?ScanResult=" + encodeURIComponent(JSON.stringify({ ...data, ...this.chargServiceItem }))
        }
    }
}
</script>
<style lang="less" scoped>
.home {
    height: 100%;
    overflow: hidden;

    .van-search {
        border-bottom: 1px solid #fafafa;
        margin-bottom: 10px;
    }

    /deep/ .van-tree-select {
        height: calc(100% - 115px) !important;
        overflow: hidden;

        .van-sidebar {
            flex: none;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
        }

        .van-tree-select__content {
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            .van-grid {
                &-item {
                    h6 {
                        margin: 0;
                        white-space: nowrap;
                        width: 50px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    strong {
                        display: block;
                        font-size: 18px;
                        color: green;
                        margin: 18px 0;
                    }

                    p {
                        font-size: 10px;
                        color: #555;
                        margin: 10px 0 0;
                        white-space: nowrap;
                    }
                }
            }

            .van-card__title {
                text-align: left;
            }

            .van-card__bottom {
                display: flex;
                justify-content: space-between;

                .van-card__num {
                    float: none;
                }
            }
        }
    }
}
</style>